import { IColumn } from '../../../core/components/Table'
import { formatDateTime } from '../../../core/constants/times'

const ticketColumnSerial: IColumn[] = [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'barcode',
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'date',
    sortable: true,
    render: (row) => <span>{formatDateTime(row.date)}</span>,
  },
]

const ticketColumnBarcode: IColumn[] = [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'barcode',
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'date',
    sortable: true,
    render: (row) => <span>{formatDateTime(row.date)}</span>,
  },
]

const ticketColumnEmail: IColumn[] = [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'barcode',
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'date',
    sortable: true,
    render: (row) => <span>{formatDateTime(row.date)}</span>,
  },
]

const ticketColumnTopup: IColumn[] = [
  {
    title: 'Email',
    accessor: 'email',
    sortable: true,
  },
  {
    title: 'Barcode',
    accessor: 'barcode',
    sortable: true,
  },
  {
    title: 'Date',
    accessor: 'date',
    sortable: true,
    render: (row) => <span>{formatDateTime(row.date)}</span>,
  },
]

export const getBarcodeColumn = (
  searchBy: 'serial' | 'barcode' | 'email' | 'topupOrder',
) => {
  switch (searchBy) {
    case 'serial':
      return ticketColumnSerial
    case 'barcode':
      return ticketColumnBarcode
    case 'email':
      return ticketColumnEmail
    case 'topupOrder':
      return ticketColumnTopup
    default:
      return ticketColumnSerial
  }
}
